<template>
<!-- MODAL -->
<TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6"
            >
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">
                  {{ title }}
                </h2>
                <button
                  @click="closeDialog"
                  type="button"
                  class="text-gray-400 hover:text-gray-600 -mt-4"
                >
                  <span class="sr-only">Fechar</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <!-- Conteúdo do modal -->
              <div class="p-6 bg-gray-50 rounded-lg shadow-md">
                <h2 class="text-xl font-semibold text-gray-700 mb-4">Resumo de Dados</h2>

                <div v-for="(value, key) in data" :key="key" class="mb-6">
                  <template v-if="Array.isArray(value)">
                    <h3 class="text-lg font-semibold text-blue-800 capitalize mb-2">{{ key }}</h3>
                    <ul class="list-none pl-4 space-y-2">
                      <li
                        v-for="(item, index) in value"
                        :key="index"
                        class="border p-2 rounded-md bg-gray-100"
                      >
                        <div
                          v-if="typeof item === 'object'"
                          class="space-y-1"
                        >
                          <div
                            v-for="(subValue, subKey) in item"
                            :key="subKey"
                            class="text-sm"
                          >
                            <strong class="text-gray-700">{{ subKey }}:</strong>
                            <span class="text-gray-600">{{ subValue }}</span>
                          </div>
                        </div>
                        <span v-else class="text-gray-600">{{ item }}</span>
                      </li>
                    </ul>
                  </template>

                  <template v-else-if="typeof value === 'object' && value !== null">
                    <h3 class="text-lg font-semibold text-blue-800 capitalize mb-2">{{ key }}</h3>
                    <div class="pl-5 space-y-1">
                      <div
                        v-for="(subValue, subKey) in value"
                        :key="subKey"
                        class="text-sm"
                      >
                        <strong class="text-gray-700">{{ subKey }}:</strong>
                        <span class="text-gray-600">{{ subValue }}</span>
                      </div>
                    </div>
                  </template>

                  <template v-else>
                    <div class="text-sm">
                      <strong class="text-gray-700 capitalize">{{ key }}:</strong>
                      <span class="text-gray-600">{{ value }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

    export default {
        name: 'ListaDeAgendamentosCommonView',
        props: {
            data: {
                type: Object,
                required: true
            },
            open: {
                type: Boolean,
                required: true
            },
            title: {
                type: String,
                required: true
            },
        },
        methods:{
            closeDialog() {
            this.$emit('update-open', false);
        },
        },
        components:{
            Dialog, 
            DialogPanel, 
            TransitionChild, 
            TransitionRoot 
        }
    }
</script>
  
  